/* eslint-disable */
import { onLoad } from '@/helpers/onLoad'

export default () => {
  onLoad(() => (function e () { const e = document.createElement('script'); e.type = 'text/javascript', e.async = !0, e.src = '//staticw2.yotpo.com/SctVwKsLBwVIgxjZSNgIbkF667dhAD94ZFq80iZJ/widget.js'; const t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(e, t) })())
}
